import React from 'react';

import Select, { components } from 'react-select';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { SHARE_FEEDBACK_TYPES } from 'constants/ProjectConstants';
import { FeedbackSvgIcon, PraiseSvgIcon } from 'constants/icons';

export const FeedbackIconPack = {
  PositiveSentiment: <PraiseSvgIcon containerSize="fixed16px" size="fixed16px" />,
  NegativeSentiment: <FeedbackSvgIcon containerSize="fixed16px" size="fixed16px" />,
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

function IconOption(props) {
  const { data } = props;
  const { Option } = components;
  return (
    <Option {...props}>
      <StyledContainer>
        {FeedbackIconPack[data.icon]}
        <StyledTypography display="inline" leftGutter={1}>
          {data.label}
        </StyledTypography>
      </StyledContainer>
    </Option>
  );
}

function SingleValueIcon(props) {
  const { data } = props;
  const { SingleValue } = components;
  return (
    <SingleValue {...props}>
      <StyledContainer>
        {FeedbackIconPack[data.icon]}
        <StyledTypography display="inline" leftGutter={1}>
          {data.label}
        </StyledTypography>
      </StyledContainer>
    </SingleValue>
  );
}

const SelectFeedbackType = ({ value = SHARE_FEEDBACK_TYPES[0], onChange = () => {} }) => (
  <Select
    value={value}
    options={SHARE_FEEDBACK_TYPES}
    components={{ Option: IconOption, SingleValue: SingleValueIcon }}
    onChange={onChange}
  />
);

export default SelectFeedbackType;
